module.exports = __webpack_public_path__ + "img/process-icon-3.a36f6d54.svg";